/** "41ms" under a second, "47s" under a minute, "6m 52s" under an hour, "1h 2m" above it. */
export function formatDuration(seconds: number): string {
  const milliseconds = Math.round(seconds * 1000);

  if (milliseconds < 1000) return `${milliseconds}ms`;

  const whole = Math.floor(milliseconds / 1000);

  if (whole < 60) return `${whole}s`;

  if (whole < 3600) return `${Math.floor(whole / 60)}m ${whole % 60}s`;

  return `${Math.floor(whole / 3600)}h ${Math.floor((whole % 3600) / 60)}m`;
}
